import { z } from 'zod';

import { BankVerifyFormModel } from 'src/constants';
import { ServiceDetailsSchema } from 'src/routes/payments/services/service-details/components/EditServiceDetails';
import { ServiceSchema } from 'src/routes/payments/services/types';
import { PaymentMethodType } from 'src/services/api/invoicesApi';

const paymentMethodSchema = z.enum([
  PaymentMethodType.BankAccount,
  PaymentMethodType.CreditCard,
]);

export const paymentPreferencesSchema = z.object({
  paymentMethodTypes: z
    .array(paymentMethodSchema)
    .min(1, { message: 'At least one payment method is required' }),
  absorbTransactionFee: z.array(paymentMethodSchema),
});

export enum FeePayer {
  Internal = 'us',
  Client = 'client',
}

export const isValidFeePayer = (value: string): value is FeePayer => {
  return value === FeePayer.Internal || value === FeePayer.Client;
};
export interface BankVerifyActionProps {
  onVerify: (values: BankVerifyFormModel) => Promise<void>;
}

export type ProductFormType<Mode> = Mode extends 'edit'
  ? ServiceDetailsSchema
  : ServiceSchema;
